export const accordion = () => {
  $(function () {
    $(".js-accordion").each(function () {
      $(this).click(function () {
        $(this).toggleClass("is-open");
        $(this).next().stop().slideToggle();
      });
    });

    // sp時のみ動作するアコーディオン
    $(".js-accordion-sp").each(function () {
      $(this).click(function () {
        if (window.innerWidth <= 768) {
          // SP用のイベントを登録
          $(this).toggleClass("is-open");
          $(this).next().stop().slideToggle();
        }
      });
    });
  });
};
